import {ReactElement} from "react";

const AboutPage = ():ReactElement => {

  return (
    <div>
      ABOUT
    </div>
  )
}

export default AboutPage;